// ─────────────────────────────────────────────
//  Pure utility helpers for the folder tree
// ─────────────────────────────────────────────

import type { FolderItem } from "../types/sharepoint";

/** Recursively replace the `children` of the node with `targetId`. */
export function updateNodeChildren(
  tree: FolderItem[],
  targetId: string,
  children: FolderItem[]
): FolderItem[] {
  return tree.map((node) => {
    if (node.id === targetId) return { ...node, children };
    if (node.children)
      return { ...node, children: updateNodeChildren(node.children, targetId, children) };
    return node;
  });
}

/** Return only folders (and their parents) whose name matches `query`. */
export function filterFolders(folders: FolderItem[], query: string): FolderItem[] {
  const q = query.trim().toLowerCase();
  if (!q) return folders;

  return folders.reduce<FolderItem[]>((acc, folder) => {
    const matchingChildren = folder.children ? filterFolders(folder.children, q) : [];
    const isMatch = folder.name.toLowerCase().includes(q);

    if (isMatch || matchingChildren.length > 0) {
      acc.push({
        ...folder,
        children: matchingChildren.length > 0 ? matchingChildren : folder.children,
      });
    }
    return acc;
  }, []);
}

/** Build a safe filename from an email subject. */
export function subjectToFilename(subject: string): string {
  return `${subject.replace(/[^a-zA-Z0-9_\-. ]/g, "_")}.eml`;
}
